import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import {useState} from 'react';

interface EmailSignInFormProps {
  loading: boolean;
  disabled: boolean;
  onSignIn: (email: string, password: string) => void;
}

export default function EmailSignInForm({loading, disabled, onSignIn}: EmailSignInFormProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = () => {
    onSignIn(email, password);
  };

  return (
    <>
      <Divider sx={{my: 3}}>
        <Typography variant="body2" color="text.secondary">
          or
        </Typography>
      </Divider>

      <Box component="form" sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
        <TextField
          fullWidth
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={disabled}
          required
          autoComplete="email"
          inputProps={{'data-testid': 'email-input'}}
        />
        <TextField
          fullWidth
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={disabled}
          required
          autoComplete="current-password"
          inputProps={{'data-testid': 'password-input'}}
        />
        <Button
          fullWidth
          variant="outlined"
          size="large"
          onClick={handleSubmit}
          disabled={disabled || !email || !password}
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
          data-testid="email-sign-in-button"
          sx={{
            py: 1.5,
            fontSize: '1.1rem',
            fontWeight: 600,
          }}
        >
          {loading ? 'Signing in...' : 'Sign in with Email'}
        </Button>
      </Box>
    </>
  );
}
